<div class="container">
  <h1>Te form review</h1>

  <div class="row">
    <h3 class="col-sm-12" style="text-align: center;">{{currentVerb.text}}</h3>
    <h5 class="col-sm-12" style="text-align: center;">{{currentVerb.trans}}</h5>
    
    <div class="col-sm-12">
      <form>
        <div class="input-group mb-3">
          <input [(ngModel)]="answer.text" name="answer" type="text" class="form-control" placeholder="Your answer" aria-label="Your answer" aria-describedby="basic-addon2">
          <div class="input-group-append">
            <button class="btn btn-outline-secondary" type="submit" (click)="submitAnswer()">Submit</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

